// noinspection JSUnusedLocalSymbols,JSUnusedGlobalSymbols

import { Injectable } from '@angular/core';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { ApiService } from './api.service';
import { ServerResponse } from '../../interfaces/base/server.response';
import { ApiEndpointsService } from './api-endpoints.service';
import { AddressBookType } from '../../interfaces/configuration/address-book-type';
import { environment } from '../../../environments/environment';
import { Organisation } from '../../interfaces/routering/organisation';
import { Department } from '../../interfaces/routering/department';
import { User } from '../../interfaces/routering/user';
import { City } from '../../interfaces/configuration/city';
import { Role } from '../../interfaces/routering/role';
import { MailType } from '../../interfaces/configuration/mail-type';
import { ReportHistoryType } from '../../interfaces/configuration/report-history-type';
import { ReportSource } from '../../interfaces/configuration/report-source';
import { ReportStatus } from '../../interfaces/configuration/report-status';
import { HeadCategory } from '../../interfaces/routering/head-category';
import { SubCategory } from '../../interfaces/routering/sub-category';
import { AddressBook } from '../../interfaces/configuration/address-book';
import { StandardReaction } from '../../interfaces/configuration/standard-reaction';
import { IntegratedOptions } from '../../interfaces/base/integrated-options';
import { ChangelogType } from '../../interfaces/configuration/changelog-type';
import { PublicNotificationType } from '../../interfaces/configuration/public-notification-type';
import { ContentVisibility } from '../../interfaces/configuration/content-visibility';
import { Report } from '../../interfaces/report/report';
import { Permission } from '../../interfaces/routering/permission';
import { MailTag } from '../../interfaces/sent-emails/mail-tag';
import { MailEvent } from '../../interfaces/sent-emails/mail-event';
import { MailLogLevel } from '../../interfaces/sent-emails/mail-log-level';
import { FilterData, Filters } from '../../interfaces/base/filters';
import { ReportPriority } from '../../interfaces/report/report-priority';
import { DomainType } from '../../interfaces/configuration/domain-type';
import { BlacklistType } from '../../interfaces/configuration/blacklist-type';
import { WasteOrderStatus } from '../../interfaces/configuration/waste-order-status';
import { WasteOrderType } from '../../interfaces/configuration/waste-order-type';
import { WasteType } from '../../interfaces/waste-calendar/waste-type';
import { WasteImportSerie } from '../../interfaces/waste-calendar/waste-import-serie';
import { WasteRouteGroup } from '../../interfaces/waste-calendar/waste-route-group';
import { Month } from '../../interfaces/base/month';
import { DepartmentAndUser } from '../../interfaces/routering/department-and-user';
import { BroadcastService } from './broadcast.service';
import { PostalcodeGroup } from '../../interfaces/configuration/postalcode-group';
import { Module } from '../../interfaces/configuration/module';
import { Route } from '../../interfaces/waste-calendar/route';
import { Dataset } from '../../interfaces/waste-calendar/dataset';
import { Location } from '../../interfaces/waste-calendar/location';

@Injectable({
  providedIn: 'root'
})

export class FiltersService {

  public filters: Filters = null;

  private filterData: FilterData = {
    addressBook: [],
    addressBookTypes: [],
    archiveUsers: [],
    archiveUsersAll: [],
    blacklistTypes: [],
    changelogTypes: [],
    cities: [],
    contentVisibility: [],
    departments: [],
    departmentsAndUsers: [],
    domainTypes: [],
    headCategories: [],
    historyEntries: [],
    historyTypes: [],
    mailEvents: [],
    mailLogLevels: [],
    mailSubjects: [],
    mailTags: [],
    mailTypes: [],
    organisations: [],
    permissionGroups: [],
    permissions: [],
    postalcodeGroups: [],
    publicNotificationTypes: [],
    reportPriorities: [],
    reportSources: [],
    reportStatuses: [],
    roles: [],
    standardReactions: [],
    subCategories: [],
    users: [],
    usersCanBeAssigned: [],

    wasteCalendarDatasets: [],
    wasteCalendarWasteTypes: [],
    wasteCalendarLocations: [],
    wasteCalendarRoutes: [],

    wasteDataRouteGroups: [],
    wasteOrderStatuses: [],
    wasteOrderTypes: [],
    wastePostalcodeRouteGroups: [],
    wasteTypes: [],
  };

  constructor(private api: ApiService,
              private apiEndpoints: ApiEndpointsService,
              private broadcastService: BroadcastService,
  ) {
  }

  activeStatuses(): Observable<IntegratedOptions[]> {
    return new Observable<IntegratedOptions[]>((o: Subscriber<IntegratedOptions[]>): void => {
      o.next([
        {
          name: 'Alle',
          id: null
        },
        {
          name: 'Ja',
          id: true
        },
        {
          name: 'Nee',
          id: false
        }
      ]);
    });
  }

  yesNo(): Observable<IntegratedOptions[]> {
    return new Observable<IntegratedOptions[]>((o: Subscriber<IntegratedOptions[]>): void => {
      o.next([
        {
          name: 'Ja',
          id: true
        },
        {
          name: 'Nee',
          id: false
        }
      ]);
    });
  }

  yesNoUnknown(): Observable<IntegratedOptions[]> {
    return new Observable<IntegratedOptions[]>((o: Subscriber<IntegratedOptions[]>): void => {
      o.next([
        {
          name: 'Ja',
          id: 'Ja'
        },
        {
          name: 'Nee',
          id: 'Nee'
        },
        {
          name: 'Onbekend',
          id: 'Onbekend'
        }
      ]);
    });
  }

  personPrefix(): Observable<IntegratedOptions[]> {
    return new Observable<IntegratedOptions[]>((o: Subscriber<IntegratedOptions[]>): void => {
      o.next([
        {
          name: 'Heer',
          id: 'Heer'
        },
        {
          name: 'Mevrouw',
          id: 'Mevrouw'
        },
        {
          name: 'Neutraal',
          id: 'Neutraal',
        }
      ]);
    });
  }

  reportAssignToTypes(): Observable<IntegratedOptions[]> {
    return new Observable<IntegratedOptions[]>((o: Subscriber<IntegratedOptions[]>): void => {
      o.next([
        {
          name: 'Geen',
          id: null,
        },
        {
          name: 'Gebruiker',
          id: 'users'
        },
        {
          name: 'Afdelingen',
          id: 'departments'
        },
      ]);
    });
  }

  archiveCollectionStatus(): Observable<IntegratedOptions[]> {
    return new Observable<IntegratedOptions[]>((o: Subscriber<IntegratedOptions[]>): void => {
      o.next([
        {
          id: 'created',
          name: 'Aangemaakt'
        },
        {
          id: 'in-review',
          name: 'Beoordelen'
        },
        {
          id: 'rejected',
          name: 'Afgewezen'
        },
        {
          id: 'approved',
          name: 'Geaccordeerd'
        },
        {
          id: 'destroyed',
          name: 'Vernietigd'
        },
      ]);
    });
  }

  for(): Observable<IntegratedOptions[]> {
    return new Observable<IntegratedOptions[]>((o: Subscriber<IntegratedOptions[]>): void => {
      o.next([
        {
          name: 'Alle',
          id: null
        },
        {
          name: 'Afwijzen',
          id: 'rejected'
        },
        {
          name: 'Tussenbericht',
          id: 'future'
        },
        {
          name: 'Voltooien',
          id: 'resolved'
        },
      ]);
    });
  }

  months(): Observable<Month[]> {
    return new Observable<Month[]>((o: Subscriber<Month[]>): void => {
      o.next([
        {
          name: 'Januari',
          short_name: 'Jan',
          id: 1
        },
        {
          name: 'Februari',
          short_name: 'Feb',
          id: 2
        },
        {
          name: 'Maart',
          short_name: 'Maa',
          id: 3
        },
        {
          name: 'April',
          short_name: 'Apr',
          id: 4
        },
        {
          name: 'Mei',
          short_name: 'Mei',
          id: 5
        },
        {
          name: 'Juni',
          short_name: 'Jun',
          id: 6
        },
        {
          name: 'Juli',
          short_name: 'Jul',
          id: 7
        },
        {
          name: 'Augustus',
          short_name: 'Aug',
          id: 8
        },
        {
          name: 'September',
          short_name: 'Sep',
          id: 9
        },
        {
          name: 'Oktober',
          short_name: 'Okt',
          id: 10
        },
        {
          name: 'November',
          short_name: 'Nov',
          id: 11
        },
        {
          name: 'December',
          short_name: 'Dec',
          id: 12
        },
      ]);
    });
  }

  publicNotificationVisibility(): Observable<IntegratedOptions[]> {
    return new Observable<IntegratedOptions[]>((o: Subscriber<IntegratedOptions[]>): void => {
      o.next([
        {
          name: 'Afvalkalender',
          id: 'waste-calendar'
        },
        {
          name: 'Meldformulier',
          id: 'webform'
        }
      ]);
    });
  }

  organisations(): Observable<Organisation[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<Organisation[]>((o: Subscriber<Organisation[]>) => {
      const emitData = (data: Organisation[]): void => {
        o.next(data);
        this.broadcastService.clearStale('organisations.changed');

        this.filterData.organisations = data;
        if (this.filters?.organisations) {
          this.filters.organisations.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<Organisation[]> => {
        if (this.filters?.organisations) {
          this.filters.organisations.isLoading = true;
        }
        return this.getOrganisations();
      };

      if (this.filterData.organisations.length && !this.broadcastService.isStale('organisations.changed')) {
        o.next(this.filterData.organisations);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('organisations', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: organisations.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getOrganisations(): Observable<Organisation[]> {
    return new Observable<Organisation[]>((o: Subscriber<Organisation[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.organisations'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });
      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  departments(): Observable<Department[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<Department[]>((o: Subscriber<Department[]>) => {
      const emitData = (data: Department[]): void => {
        o.next(data);
        this.broadcastService.clearStale('departments.changed');

        this.filterData.departments = data;
        if (this.filters?.departments) {
          this.filters.departments.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<Department[]> => {
        if (this.filters?.departments) {
          this.filters.departments.isLoading = true;
        }
        return this.getDepartments();
      };

      if (this.filterData.departments.length && !this.broadcastService.isStale('departments.changed')) {
        o.next(this.filterData.departments);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('departments', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: departments.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getDepartments(): Observable<Department[]> {
    return new Observable<Department[]>((o: Subscriber<Department[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.departments'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  departmentsAndUsers(): Observable<DepartmentAndUser[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsSub2: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<DepartmentAndUser[]>((o: Subscriber<DepartmentAndUser[]>) => {
      const emitData = (data: DepartmentAndUser[]): void => {
        o.next(data);
        this.broadcastService.clearStale('departments.changed');
        this.broadcastService.clearStale('users.changed');

        this.filterData.departmentsAndUsers = data;
        if (this.filters?.departmentsAndUsers) {
          this.filters.departmentsAndUsers.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<DepartmentAndUser[]> => {
        if (this.filters?.departmentsAndUsers) {
          this.filters.departmentsAndUsers.isLoading = true;
        }
        return this.getDepartmentsAndUsers();
      };

      if (this.filterData.departmentsAndUsers.length && (!this.broadcastService.isStale('departments.changed') || !this.broadcastService.isStale('users.changed'))) {
        o.next(this.filterData.departmentsAndUsers);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('departments', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: departments.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      wsSub2 = this.broadcastService.getEventSubject('users', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: users.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsSub2?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getDepartmentsAndUsers(): Observable<DepartmentAndUser[]> {
    return new Observable<DepartmentAndUser[]>((o: Subscriber<DepartmentAndUser[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.departments-and-users'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  departmentUsers(department_id: number): Observable<User[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsSub2: Subscription = null,
      wsDataSub: Subscription = null,
      wsDataSub2: Subscription = null;
    return new Observable<User[]>((o: Subscriber<User[]>) => {
      const emitData = (data: User[]): void => {
        o.next(data);
        if (this.filters?.departmentUsers) {
          this.filters.departmentUsers.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<User[]> => {
        if (this.filters?.departmentUsers) {
          this.filters.departmentUsers.isLoading = true;
        }
        return this.getDepartmentUsers(department_id);
      };

      initialSub = loadFromServer().subscribe(emitData);

      wsSub = this.broadcastService.getEventSubject('users', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: users.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      wsSub2 = this.broadcastService.getEventSubject('departments', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: departments.changed');
        }

        wsDataSub2?.unsubscribe();

        wsDataSub2 = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsSub2?.unsubscribe();
        wsDataSub?.unsubscribe();
        wsDataSub2?.unsubscribe();
      };
    });
  }

  getDepartmentUsers(department_id: number): Observable<User[]> {
    return new Observable<User[]>((o: Subscriber<User[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.department-users', {':id': department_id}), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }


  cities(): Observable<City[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<City[]>((o: Subscriber<City[]>) => {
      const emitData = (data: City[]): void => {
        o.next(data);
        this.filterData.cities = data;
        this.broadcastService.clearStale('cities.changed');

        if (this.filters?.cities) {
          this.filters.cities.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<City[]> => {
        if (this.filters?.cities) {
          this.filters.cities.isLoading = true;
        }
        return this.getCities();
      };

      if (this.filterData.cities.length && !this.broadcastService.isStale('cities.changed')) {
        o.next(this.filterData.cities);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('cities', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: cities.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getCities(): Observable<City[]> {
    return new Observable<City[]>((o: Subscriber<City[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.cities'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  permissions(): Observable<Permission[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<Permission[]>((o: Subscriber<Permission[]>) => {
      const emitData = (data: Permission[]): void => {
        o.next(data);
        this.filterData.permissions = data;
        this.broadcastService.clearStale('permissions.changed');

        if (this.filters?.permissions) {
          this.filters.permissions.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<Permission[]> => {
        if (this.filters?.permissions) {
          this.filters.permissions.isLoading = true;
        }
        return this.getPermissions();
      };

      if (this.filterData.permissions.length && !this.broadcastService.isStale('permissions.changed')) {
        o.next(this.filterData.permissions);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('permissions', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: permissions.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getPermissions(): Observable<Permission[]> {
    return new Observable<Permission[]>((o: Subscriber<Permission[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.permissions'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  permissionGroups(): Observable<Permission[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<Permission[]>((o: Subscriber<Permission[]>) => {
      const emitData = (data: Permission[]): void => {
        o.next(data);
        this.filterData.permissionGroups = data;
        this.broadcastService.clearStale('permissionGroups.changed');

        if (this.filters?.permissionGroups) {
          this.filters.permissionGroups.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<Permission[]> => {
        if (this.filters?.permissionGroups) {
          this.filters.permissionGroups.isLoading = true;
        }
        return this.getPermissionGroups();
      };

      if (this.filterData.permissionGroups.length && !this.broadcastService.isStale('permissionGroups.changed')) {
        o.next(this.filterData.permissionGroups);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('permissionGroups', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: permissionGroups.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getPermissionGroups(): Observable<Permission[]> {
    return new Observable<Permission[]>((o: Subscriber<Permission[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.permission-groups'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  roles(): Observable<Role[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<Role[]>((o: Subscriber<Role[]>) => {
      const emitData = (data: Role[]): void => {
        o.next(data);
        this.filterData.roles = data;
        this.broadcastService.clearStale('roles.changed');

        if (this.filters?.roles) {
          this.filters.roles.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<Role[]> => {
        if (this.filters?.roles) {
          this.filters.roles.isLoading = true;
        }
        return this.getRoles();
      };

      if (this.filterData.roles.length && !this.broadcastService.isStale('roles.changed')) {
        o.next(this.filterData.roles);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('roles', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: roles.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getRoles(): Observable<Role[]> {
    return new Observable<Role[]>((o: Subscriber<Role[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.roles'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  users(): Observable<User[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<User[]>((o: Subscriber<User[]>) => {
      const emitData = (data: User[]): void => {
        o.next(data);
        this.filterData.users = data;
        this.broadcastService.clearStale('users.changed');

        if (this.filters?.users) {
          this.filters.users.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<User[]> => {
        if (this.filters?.users) {
          this.filters.users.isLoading = true;
        }
        return this.getUsers();
      };

      if (this.filterData.users.length && !this.broadcastService.isStale('users.changed')) {
        o.next(this.filterData.users);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('users', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: users.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getUsers(): Observable<User[]> {
    return new Observable<User[]>((o: Subscriber<User[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.users'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  usersCanBeAssigned(): Observable<User[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<User[]>((o: Subscriber<User[]>) => {
      const emitData = (data: User[]): void => {
        o.next(data);
        this.filterData.usersCanBeAssigned = data;
        this.broadcastService.clearStale('users.changed');

        if (this.filters?.usersCanBeAssigned) {
          this.filters.usersCanBeAssigned.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<User[]> => {
        if (this.filters?.usersCanBeAssigned) {
          this.filters.usersCanBeAssigned.isLoading = true;
        }
        return this.getUsersCanBeAssigned();
      };

      if (this.filterData.usersCanBeAssigned.length && !this.broadcastService.isStale('users.changed')) {
        o.next(this.filterData.usersCanBeAssigned);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('users', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: users.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getUsersCanBeAssigned(): Observable<User[]> {
    return new Observable<User[]>((o: Subscriber<User[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.users.can-be-assigned'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  archiveUsers(): Observable<User[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<User[]>((o: Subscriber<User[]>) => {
      const emitData = (data: User[]): void => {
        o.next(data);
        this.filterData.archiveUsers = data;
        this.broadcastService.clearStale('users.changed');

        if (this.filters?.archiveUsers) {
          this.filters.archiveUsers.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<User[]> => {
        if (this.filters?.archiveUsers) {
          this.filters.archiveUsers.isLoading = true;
        }
        return this.getArchiveUsers();
      };

      if (this.filterData.archiveUsers.length && !this.broadcastService.isStale('users.changed')) {
        o.next(this.filterData.archiveUsers);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('users', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: users.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getArchiveUsers(): Observable<User[]> {
    return new Observable<User[]>((o: Subscriber<User[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('archive.archivering.users'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  archiveUsersAll(): Observable<User[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<User[]>((o: Subscriber<User[]>) => {
      const emitData = (data: User[]): void => {
        o.next(data);
        this.filterData.archiveUsersAll = data;
        this.broadcastService.clearStale('users.changed');

        if (this.filters?.archiveUsersAll) {
          this.filters.archiveUsersAll.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<User[]> => {
        if (this.filters?.archiveUsersAll) {
          this.filters.archiveUsersAll.isLoading = true;
        }
        return this.getArchiveUsersAll();
      };

      if (this.filterData.archiveUsersAll.length && !this.broadcastService.isStale('users.changed')) {
        o.next(this.filterData.archiveUsersAll);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('users', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: users.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getArchiveUsersAll(): Observable<User[]> {
    return new Observable<User[]>((o: Subscriber<User[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('archive.archivering.users.all'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }


  mailTypes(): Observable<MailType[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<MailType[]>((o: Subscriber<MailType[]>) => {
      const emitData = (data: MailType[]): void => {
        o.next(data);
        this.filterData.mailTypes = data;
        this.broadcastService.clearStale('mailTypes.changed');

        if (this.filters?.mailTypes) {
          this.filters.mailTypes.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<MailType[]> => {
        if (this.filters?.mailTypes) {
          this.filters.mailTypes.isLoading = true;
        }
        return this.getMailTypes();
      };

      if (this.filterData.mailTypes.length && !this.broadcastService.isStale('mailTypes.changed')) {
        o.next(this.filterData.mailTypes);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('mailTypes', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: mailTypes.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getMailTypes(): Observable<MailType[]> {
    return new Observable<MailType[]>((o: Subscriber<MailType[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.mail-types'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  modules(): Observable<Module[]> {
    let initialSub: Subscription = null;
    return new Observable<Module[]>((o: Subscriber<Module[]>) => {
      const emitData = (data: Module[]): void => {
        o.next(data);
        if (this.filters?.modules) {
          this.filters.modules.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<Module[]> => {
        if (this.filters?.modules) {
          this.filters.modules.isLoading = true;
        }
        return this.getModules();
      };

      initialSub = loadFromServer().subscribe(emitData);

      return (): void => {
        initialSub?.unsubscribe();
      };
    });
  }

  getModules(): Observable<Module[]> {
    return new Observable<Module[]>((o: Subscriber<Module[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.modules'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }


  historyTypes(): Observable<ReportHistoryType[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<ReportHistoryType[]>((o: Subscriber<ReportHistoryType[]>) => {
      const emitData = (data: ReportHistoryType[]): void => {
        o.next(data);
        this.filterData.historyTypes = data;
        this.broadcastService.clearStale('reportHistoryTypes.changed');

        if (this.filters?.historyTypes) {
          this.filters.historyTypes.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<ReportHistoryType[]> => {
        if (this.filters?.historyTypes) {
          this.filters.historyTypes.isLoading = true;
        }
        return this.getHistoryTypes();
      };

      if (this.filterData.historyTypes.length && !this.broadcastService.isStale('reportHistoryTypes.changed')) {
        o.next(this.filterData.historyTypes);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('reportHistoryTypes', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: reportHistoryTypes.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getHistoryTypes(): Observable<ReportHistoryType[]> {
    return new Observable<ReportHistoryType[]>((o: Subscriber<ReportHistoryType[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.report-history-types'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  reportPriorities(): Observable<ReportPriority[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<ReportPriority[]>((o: Subscriber<ReportPriority[]>) => {
      const emitData = (data: ReportPriority[]): void => {
        o.next(data);
        this.filterData.reportPriorities = data;
        this.broadcastService.clearStale('reportPriorities.changed');

        if (this.filters?.reportPriorities) {
          this.filters.reportPriorities.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<ReportPriority[]> => {
        if (this.filters?.reportPriorities) {
          this.filters.reportPriorities.isLoading = true;
        }
        return this.getReportPriorities();
      };

      if (this.filterData.reportPriorities.length && !this.broadcastService.isStale('reportPriorities.changed')) {
        o.next(this.filterData.reportPriorities);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('reportPriorities', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: reportPriorities.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getReportPriorities(): Observable<ReportPriority[]> {
    return new Observable<ReportPriority[]>((o: Subscriber<ReportPriority[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.report-priorities'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  domainTypes(): Observable<DomainType[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<DomainType[]>((o: Subscriber<DomainType[]>) => {
      const emitData = (data: DomainType[]): void => {
        o.next(data);
        this.filterData.domainTypes = data;
        this.broadcastService.clearStale('domainTypes.changed');

        if (this.filters?.domainTypes) {
          this.filters.domainTypes.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<DomainType[]> => {
        if (this.filters?.domainTypes) {
          this.filters.domainTypes.isLoading = true;
        }
        return this.getDomainTypes();
      };

      if (this.filterData.domainTypes.length && !this.broadcastService.isStale('domainTypes.changed')) {
        o.next(this.filterData.domainTypes);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('domainTypes', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: domainTypes.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getDomainTypes(): Observable<DomainType[]> {
    return new Observable<DomainType[]>((o: Subscriber<DomainType[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.domain-types'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  reportSources(): Observable<ReportSource[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<ReportSource[]>((o: Subscriber<ReportSource[]>) => {
      const emitData = (data: ReportSource[]): void => {
        o.next(data);
        this.filterData.reportSources = data;
        this.broadcastService.clearStale('reportSources.changed');

        if (this.filters?.reportSources) {
          this.filters.reportSources.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<ReportSource[]> => {
        if (this.filters?.reportSources) {
          this.filters.reportSources.isLoading = true;
        }
        return this.getReportSources();
      };

      if (this.filterData.reportSources.length && !this.broadcastService.isStale('reportSources.changed')) {
        o.next(this.filterData.reportSources);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('reportSources', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: reportSources.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getReportSources(): Observable<ReportSource[]> {
    return new Observable<ReportSource[]>((o: Subscriber<ReportSource[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.report-sources'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  reportStatuses(): Observable<ReportStatus[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<ReportStatus[]>((o: Subscriber<ReportStatus[]>) => {
      const emitData = (data: ReportStatus[]): void => {
        o.next(data);
        this.filterData.reportStatuses = data;
        this.broadcastService.clearStale('reportStatuses.changed');

        if (this.filters?.reportStatuses) {
          this.filters.reportStatuses.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<ReportStatus[]> => {
        if (this.filters?.reportStatuses) {
          this.filters.reportStatuses.isLoading = true;
        }
        return this.getReportStatuses();
      };

      if (this.filterData.reportStatuses.length && !this.broadcastService.isStale('reportStatuses.changed')) {
        o.next(this.filterData.reportStatuses);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('reportStatuses', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: reportStatuses.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getReportStatuses(): Observable<ReportStatus[]> {
    return new Observable<ReportStatus[]>((o: Subscriber<ReportStatus[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.report-statuses'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }


  headCategories(): Observable<HeadCategory[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<HeadCategory[]>((o: Subscriber<HeadCategory[]>) => {
      const emitData = (data: HeadCategory[]): void => {
        o.next(data);
        this.filterData.headCategories = data;
        this.broadcastService.clearStale('headCategories.changed');

        if (this.filters?.headCategories) {
          this.filters.headCategories.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<HeadCategory[]> => {
        if (this.filters?.headCategories) {
          this.filters.headCategories.isLoading = true;
        }
        return this.getHeadCategories();
      };

      if (this.filterData.headCategories.length && !this.broadcastService.isStale('headCategories.changed')) {
        o.next(this.filterData.headCategories);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('headCategories', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: headCategories.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });

  }

  getHeadCategories(): Observable<HeadCategory[]> {
    return new Observable<HeadCategory[]>((o: Subscriber<HeadCategory[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.head-categories')).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  subCategories(head_category_id: number = null): Observable<SubCategory[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<SubCategory[]>((o: Subscriber<SubCategory[]>) => {
      const emitData = (data: SubCategory[]): void => {
        o.next(data);
        if (head_category_id !== null) {
          this.filterData.subCategories[head_category_id] = data;
        } else {
          this.filterData.subCategories['null'] = data;
        }
        this.broadcastService.clearStale('subCategories.changed');

        if (this.filters?.subCategories) {
          this.filters.subCategories.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<SubCategory[]> => {
        if (this.filters?.subCategories) {
          this.filters.subCategories.isLoading = true;
        }
        return this.getSubCategories(head_category_id);
      };

      if (
        (
          head_category_id === null && typeof this.filterData.subCategories['null'] !== 'undefined' && this.filterData.subCategories['null'].length ||
          head_category_id !== null && typeof this.filterData.subCategories[head_category_id] !== 'undefined' && this.filterData.subCategories[head_category_id].length
        ) && !this.broadcastService.isStale('subCategories.changed')
      ) {
        if (head_category_id !== null) {
          o.next(this.filterData.subCategories[head_category_id]);
        } else {
          o.next(this.filterData.subCategories['null']);
        }
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('subCategories', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: subCategories.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });

  }

  getSubCategories(head_category_id: number): Observable<SubCategory[]> {
    return new Observable<SubCategory[]>((o: Subscriber<SubCategory[]>) => {
      const subscription: Subscription = this.api.get((
        head_category_id
          ? this.apiEndpoints.get('filters.head-categories.sub-categories', {':head_category_id': head_category_id})
          : this.apiEndpoints.get('filters.sub-categories')
      ), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }


  addressBook(): Observable<AddressBook[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<AddressBook[]>((o: Subscriber<AddressBook[]>) => {
      const emitData = (data: AddressBook[]): void => {
        o.next(data);
        this.filterData.addressBook = data;
        this.broadcastService.clearStale('addressBooks.changed');

        if (this.filters?.addressBook) {
          this.filters.addressBook.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<AddressBook[]> => {
        if (this.filters?.addressBook) {
          this.filters.addressBook.isLoading = true;
        }
        return this.getAddressBooks();
      };

      if (this.filterData.addressBook.length && !this.broadcastService.isStale('addressBooks.changed')) {
        o.next(this.filterData.addressBook);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('addressBooks', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: addressBooks.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getAddressBooks(): Observable<AddressBook[]> {
    return new Observable<AddressBook[]>((o: Subscriber<AddressBook[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.address-book'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  addressBookTypes(): Observable<AddressBookType[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<AddressBookType[]>((o: Subscriber<AddressBookType[]>) => {
      const emitData = (data: AddressBookType[]): void => {
        o.next(data);
        this.filterData.addressBookTypes = data;
        this.broadcastService.clearStale('addressBookTypes.changed');

        if (this.filters?.addressBookTypes) {
          this.filters.addressBookTypes.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<AddressBookType[]> => {
        if (this.filters?.addressBookTypes) {
          this.filters.addressBookTypes.isLoading = true;
        }
        return this.getAddressBookTypes();
      };

      if (this.filterData.addressBookTypes.length && !this.broadcastService.isStale('addressBookTypes.changed')) {
        o.next(this.filterData.addressBookTypes);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('addressBookTypes', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: addressBookTypes.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getAddressBookTypes(): Observable<AddressBookType[]> {
    return new Observable<AddressBookType[]>((o: Subscriber<AddressBookType[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.address-book-types'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  standardReactions(): Observable<StandardReaction[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<StandardReaction[]>((o: Subscriber<StandardReaction[]>) => {
      const emitData = (data: StandardReaction[]): void => {
        o.next(data);
        this.filterData.standardReactions = data;
        this.broadcastService.clearStale('standardReactions.changed');

        if (this.filters?.standardReactions) {
          this.filters.standardReactions.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<StandardReaction[]> => {
        if (this.filters?.standardReactions) {
          this.filters.standardReactions.isLoading = true;
        }
        return this.getStandardReactions();
      };

      if (this.filterData.standardReactions.length && !this.broadcastService.isStale('standardReactions.changed')) {
        o.next(this.filterData.standardReactions);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('standardReactions', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: standardReactions.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getStandardReactions(): Observable<StandardReaction[]> {
    return new Observable<StandardReaction[]>((o: Subscriber<StandardReaction[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.standard-reactions'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  historyEntries(): Observable<ReportHistoryType[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<ReportHistoryType[]>((o: Subscriber<ReportHistoryType[]>) => {
      const emitData = (data: ReportHistoryType[]): void => {
        o.next(data);
        this.filterData.historyEntries = data;
        this.broadcastService.clearStale('reportHistoryEntries.changed');

        if (this.filters?.historyEntries) {
          this.filters.historyEntries.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<ReportHistoryType[]> => {
        if (this.filters?.historyEntries) {
          this.filters.historyEntries.isLoading = true;
        }
        return this.getHistoryEntries();
      };

      if (this.filterData.historyEntries.length && !this.broadcastService.isStale('reportHistoryEntries.changed')) {
        o.next(this.filterData.historyEntries);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('reportHistoryEntries', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: reportHistoryEntries.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getHistoryEntries(): Observable<ReportHistoryType[]> {
    return new Observable<ReportHistoryType[]>((o: Subscriber<ReportHistoryType[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.report-history'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  publicNotificationTypes(): Observable<PublicNotificationType[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<PublicNotificationType[]>((o: Subscriber<PublicNotificationType[]>) => {
      const emitData = (data: PublicNotificationType[]): void => {
        o.next(data);
        this.filterData.publicNotificationTypes = data;
        this.broadcastService.clearStale('publicNotificationTypes.changed');

        if (this.filters?.publicNotificationTypes) {
          this.filters.publicNotificationTypes.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<PublicNotificationType[]> => {
        if (this.filters?.publicNotificationTypes) {
          this.filters.publicNotificationTypes.isLoading = true;
        }
        return this.getPublicNotificationTypes();
      };

      if (this.filterData.publicNotificationTypes.length && !this.broadcastService.isStale('publicNotificationTypes.changed')) {
        o.next(this.filterData.publicNotificationTypes);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('publicNotificationTypes', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: publicNotificationTypes.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getPublicNotificationTypes(): Observable<PublicNotificationType[]> {
    return new Observable<PublicNotificationType[]>((o: Subscriber<PublicNotificationType[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.public-notification-types'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }


  wasteOrderStatuses(): Observable<WasteOrderStatus[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<WasteOrderStatus[]>((o: Subscriber<WasteOrderStatus[]>) => {
      const emitData = (data: WasteOrderStatus[]): void => {
        o.next(data);
        this.filterData.wasteOrderStatuses = data;
        this.broadcastService.clearStale('wasteOrderStatuses.changed');

        if (this.filters?.wasteOrderStatuses) {
          this.filters.wasteOrderStatuses.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<WasteOrderStatus[]> => {
        if (this.filters?.wasteOrderStatuses) {
          this.filters.wasteOrderStatuses.isLoading = true;
        }
        return this.getWasteOrderStatuses();
      };

      if (this.filterData.wasteOrderStatuses.length && !this.broadcastService.isStale('wasteOrderStatuses.changed')) {
        o.next(this.filterData.wasteOrderStatuses);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('wasteOrderStatuses', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: wasteOrderStatuses.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getWasteOrderStatuses(): Observable<WasteOrderStatus[]> {
    return new Observable<WasteOrderStatus[]>((o: Subscriber<WasteOrderStatus[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.waste-order-statuses'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  wasteOrderTypes(): Observable<WasteOrderType[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<WasteOrderType[]>((o: Subscriber<WasteOrderType[]>) => {
      const emitData = (data: WasteOrderType[]): void => {
        o.next(data);
        this.filterData.wasteOrderTypes = data;
        this.broadcastService.clearStale('wasteOrderTypes.changed');

        if (this.filters?.wasteOrderTypes) {
          this.filters.wasteOrderTypes.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<WasteOrderType[]> => {
        if (this.filters?.wasteOrderTypes) {
          this.filters.wasteOrderTypes.isLoading = true;
        }
        return this.getWasteOrderTypes();
      };

      if (this.filterData.wasteOrderTypes.length && !this.broadcastService.isStale('wasteOrderTypes.changed')) {
        o.next(this.filterData.wasteOrderTypes);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('wasteOrderTypes', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: wasteOrderTypes.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getWasteOrderTypes(): Observable<WasteOrderType[]> {
    return new Observable<WasteOrderType[]>((o: Subscriber<WasteOrderType[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.waste-order-types'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  wasteDataImportSeries(): Observable<WasteImportSerie[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<WasteImportSerie[]>((o: Subscriber<WasteImportSerie[]>) => {
      const emitData = (data: WasteImportSerie[]): void => {
        o.next(data);
        if (this.filters?.wasteDataImportSeries) {
          this.filters.wasteDataImportSeries.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<WasteImportSerie[]> => {
        if (this.filters?.wasteDataImportSeries) {
          this.filters.wasteDataImportSeries.isLoading = true;
        }
        return this.getWasteDataImportSeries();
      };

      initialSub = loadFromServer().subscribe(emitData);

      wsSub = this.broadcastService.getEventSubject('wasteDataImportSerie', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: wasteDataImportSerie.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getWasteDataImportSeries(): Observable<WasteImportSerie[]> {
    return new Observable<WasteImportSerie[]>((o: Subscriber<WasteImportSerie[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.waste-calendar.waste-data-import-series'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  wastePostalcodeImportSeries(): Observable<WasteImportSerie[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<WasteImportSerie[]>((o: Subscriber<WasteImportSerie[]>) => {
      const emitData = (data: WasteImportSerie[]): void => {
        o.next(data);
        if (this.filters?.wastePostalcodeImportSeries) {
          this.filters.wastePostalcodeImportSeries.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<WasteImportSerie[]> => {
        if (this.filters?.wastePostalcodeImportSeries) {
          this.filters.wastePostalcodeImportSeries.isLoading = true;
        }
        return this.getWastePostalcodeImportSeries();
      };

      initialSub = loadFromServer().subscribe(emitData);

      wsSub = this.broadcastService.getEventSubject('wastePostalcodeImportSerie', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: wastePostalcodeImportSerie.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getWastePostalcodeImportSeries(): Observable<WasteImportSerie[]> {
    return new Observable<WasteImportSerie[]>((o: Subscriber<WasteImportSerie[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.waste-calendar.waste-postalcode-import-series'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  wasteDataRouteGroups(): Observable<WasteRouteGroup[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<WasteRouteGroup[]>((o: Subscriber<WasteRouteGroup[]>) => {
      const emitData = (data: WasteRouteGroup[]): void => {
        o.next(data);
        this.filterData.wasteDataRouteGroups = data;
        this.broadcastService.clearStale('wasteDataRouteGroups.changed');

        if (this.filters?.wasteDataRouteGroups) {
          this.filters.wasteDataRouteGroups.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<WasteRouteGroup[]> => {
        if (this.filters?.wasteDataRouteGroups) {
          this.filters.wasteDataRouteGroups.isLoading = true;
        }
        return this.getWasteDataRouteGroups();
      };

      if (this.filterData.wasteDataRouteGroups.length && !this.broadcastService.isStale('wasteOrderGroups.changed')) {
        o.next(this.filterData.wasteDataRouteGroups);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('wasteDataRouteGroups', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: wasteDataRouteGroups.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getWasteDataRouteGroups(): Observable<WasteRouteGroup[]> {
    return new Observable<WasteRouteGroup[]>((o: Subscriber<WasteRouteGroup[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.waste-calendar.waste-data-route-groups'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  wastePostalcodeRouteGroups(): Observable<WasteRouteGroup[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<WasteRouteGroup[]>((o: Subscriber<WasteRouteGroup[]>) => {
      const emitData = (data: WasteRouteGroup[]): void => {
        o.next(data);
        this.filterData.wastePostalcodeRouteGroups = data;
        this.broadcastService.clearStale('wastePostalcodeRouteGroups.changed');

        if (this.filters?.wastePostalcodeRouteGroups) {
          this.filters.wastePostalcodeRouteGroups.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<WasteRouteGroup[]> => {
        if (this.filters?.wastePostalcodeRouteGroups) {
          this.filters.wastePostalcodeRouteGroups.isLoading = true;
        }
        return this.getWastePostalcodeRouteGroups();
      };

      if (this.filterData.addressBook.length && !this.broadcastService.isStale('wastePostalcodeRouteGroups.changed')) {
        o.next(this.filterData.addressBook);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('wastePostalcodeRouteGroups', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: wastePostalcodeRouteGroups.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getWastePostalcodeRouteGroups(): Observable<WasteRouteGroup[]> {
    return new Observable<WasteRouteGroup[]>((o: Subscriber<WasteRouteGroup[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.waste-calendar.waste-postalcode-route-groups'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  wasteTypes(): Observable<WasteType[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<WasteType[]>((o: Subscriber<WasteType[]>) => {
      const emitData = (data: WasteType[]): void => {
        o.next(data);
        this.filterData.wasteTypes = data;
        this.broadcastService.clearStale('wasteTypes.changed');

        if (this.filters?.wasteTypes) {
          this.filters.wasteTypes.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<WasteType[]> => {
        if (this.filters?.wasteTypes) {
          this.filters.wasteTypes.isLoading = true;
        }
        return this.getWasteType();
      };

      if (this.filterData.wasteTypes.length && !this.broadcastService.isStale('wasteTypes.changed')) {
        o.next(this.filterData.wasteTypes);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('wasteTypes', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: wasteTypes.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getWasteType(): Observable<WasteType[]> {
    return new Observable<WasteType[]>((o: Subscriber<WasteType[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.waste-calendar.waste-types'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  postalcodeGroups(): Observable<PostalcodeGroup[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<PostalcodeGroup[]>((o: Subscriber<PostalcodeGroup[]>) => {
      const emitData = (data: PostalcodeGroup[]): void => {
        o.next(data);
        this.filterData.postalcodeGroups = data;
        this.broadcastService.clearStale('postalcodeGroups.changed');

        if (this.filters?.postalcodeGroups) {
          this.filters.postalcodeGroups.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<PostalcodeGroup[]> => {
        if (this.filters?.postalcodeGroups) {
          this.filters.postalcodeGroups.isLoading = true;
        }
        return this.getPostalcodeGroups();
      };

      if (this.filterData.postalcodeGroups.length && !this.broadcastService.isStale('postalcodeGroups.changed')) {
        o.next(this.filterData.postalcodeGroups);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('postalcodeGroups', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: postalcodeGroups.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getPostalcodeGroups(): Observable<PostalcodeGroup[]> {
    return new Observable<PostalcodeGroup[]>((o: Subscriber<PostalcodeGroup[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.postalcode-groups'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }


  blacklistTypes(): Observable<BlacklistType[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<BlacklistType[]>((o: Subscriber<BlacklistType[]>) => {
      const emitData = (data: BlacklistType[]): void => {
        o.next(data);
        this.filterData.blacklistTypes = data;
        this.broadcastService.clearStale('blacklistTypes.changed');

        if (this.filters?.blacklistTypes) {
          this.filters.blacklistTypes.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<BlacklistType[]> => {
        if (this.filters?.blacklistTypes) {
          this.filters.blacklistTypes.isLoading = true;
        }
        return this.getBlacklistTypes();
      };

      if (this.filterData.addressBook.length && !this.broadcastService.isStale('blacklistTypes.changed')) {
        o.next(this.filterData.blacklistTypes);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('blacklistTypes', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: blacklistTypes.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getBlacklistTypes(): Observable<BlacklistType[]> {
    return new Observable<BlacklistType[]>((o: Subscriber<BlacklistType[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.blacklist-types'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }


  changelogTypes(): Observable<ChangelogType[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<ChangelogType[]>((o: Subscriber<ChangelogType[]>) => {
      const emitData = (data: ChangelogType[]): void => {
        o.next(data);
        this.filterData.changelogTypes = data;
        this.broadcastService.clearStale('changelogTypes.changed');

        if (this.filters?.changelogTypes) {
          this.filters.changelogTypes.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<ChangelogType[]> => {
        if (this.filters?.changelogTypes) {
          this.filters.changelogTypes.isLoading = true;
        }
        return this.getChangelogTypes();
      };

      if (this.filterData.changelogTypes.length && !this.broadcastService.isStale('changelogTypes.changed')) {
        o.next(this.filterData.changelogTypes);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('changelogTypes', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: changelogTypes.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getChangelogTypes(): Observable<ChangelogType[]> {
    return new Observable<ChangelogType[]>((o: Subscriber<ChangelogType[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.knowledge-base.changelogs.types'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  contentVisibility(): Observable<ContentVisibility[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<ContentVisibility[]>((o: Subscriber<ContentVisibility[]>) => {
      const emitData = (data: ContentVisibility[]): void => {
        o.next(data);
        this.filterData.contentVisibility = data;
        this.broadcastService.clearStale('contentVisibility.changed');

        if (this.filters?.contentVisibility) {
          this.filters.contentVisibility.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<ContentVisibility[]> => {
        if (this.filters?.contentVisibility) {
          this.filters.contentVisibility.isLoading = true;
        }
        return this.getContentVisibility();
      };

      if (this.filterData.contentVisibility.length && !this.broadcastService.isStale('contentVisibility.changed')) {
        o.next(this.filterData.contentVisibility);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('contentVisibility', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: contentVisibility.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getContentVisibility(): Observable<ContentVisibility[]> {
    return new Observable<ContentVisibility[]>((o: Subscriber<ContentVisibility[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.content-visibility'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  reportNumbers(search: string): Observable<Report[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<Report[]>((o: Subscriber<Report[]>) => {
      const emitData = (data: Report[]): void => {
        o.next(data);
        if (this.filters?.reportNumbers) {
          this.filters.reportNumbers.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<Report[]> => {
        if (this.filters?.reportNumbers) {
          this.filters.reportNumbers.isLoading = true;
        }
        return this.getReportNumbers(search);
      };

      initialSub = loadFromServer().subscribe(emitData);

      wsSub = this.broadcastService.getEventSubject('addressBook', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: addressBook.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getReportNumbers(search: string): Observable<Report[]> {
    return new Observable<Report[]>((o: Subscriber<Report[]>) => {
      const subscription: Subscription = this.api.post(this.apiEndpoints.get('filters.report-numbers'), {search: search})
        .subscribe(
          (response: ServerResponse): void => {
            if (typeof response.data !== 'undefined') {
              o.next(response.data);
              o.complete();
            } else {
              o.next([]);
              o.complete();
            }
          }, (): void => {
            o.next([]);
            o.complete();
          },
          (): void => o.complete());

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }


  mailEvents(): Observable<MailEvent[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<MailEvent[]>((o: Subscriber<MailEvent[]>) => {
      const emitData = (data: MailEvent[]): void => {
        o.next(data);
        this.filterData.mailEvents = data;
        this.broadcastService.clearStale('mailEvents.changed');

        if (this.filters?.mailEvents) {
          this.filters.mailEvents.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<MailEvent[]> => {
        if (this.filters?.mailEvents) {
          this.filters.mailEvents.isLoading = true;
        }
        return this.getMailEvents();
      };

      if (this.filterData.mailEvents.length && !this.broadcastService.isStale('mailEvents.changed')) {
        o.next(this.filterData.mailEvents);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('mailEvents', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: mailEvents.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getMailEvents(): Observable<MailEvent[]> {
    return new Observable<MailEvent[]>((o: Subscriber<MailEvent[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.sent-emails.events'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  mailLogLevels(): Observable<MailLogLevel[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<MailLogLevel[]>((o: Subscriber<MailLogLevel[]>) => {
      const emitData = (data: MailLogLevel[]): void => {
        o.next(data);
        this.filterData.mailLogLevels = data;
        this.broadcastService.clearStale('mailLogLevels.changed');

        if (this.filters?.mailLogLevels) {
          this.filters.mailLogLevels.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<MailLogLevel[]> => {
        if (this.filters?.mailLogLevels) {
          this.filters.mailLogLevels.isLoading = true;
        }
        return this.getMailLogLevels();
      };

      if (this.filterData.mailLogLevels.length && !this.broadcastService.isStale('mailLogLevels.changed')) {
        o.next(this.filterData.mailLogLevels);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('mailLogLevels', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: mailLogLevels.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getMailLogLevels(): Observable<MailLogLevel[]> {
    return new Observable<MailLogLevel[]>((o: Subscriber<MailLogLevel[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.sent-emails.log-levels'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  mailTags(): Observable<MailTag[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<MailTag[]>((o: Subscriber<MailTag[]>) => {
      const emitData = (data: MailTag[]): void => {
        o.next(data);
        this.filterData.mailTags = data;
        this.broadcastService.clearStale('mailTags.changed');

        if (this.filters?.mailTags) {
          this.filters.mailTags.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<MailTag[]> => {
        if (this.filters?.mailTags) {
          this.filters.mailTags.isLoading = true;
        }
        return this.getMailTags();
      };

      if (this.filterData.mailTags.length && !this.broadcastService.isStale('mailTags.changed')) {
        o.next(this.filterData.mailTags);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('mailTags', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: mailTags.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getMailTags(): Observable<MailTag[]> {
    return new Observable<MailTag[]>((o: Subscriber<MailTag[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.sent-emails.tags'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }


  wasteCalendarDatasets(): Observable<Dataset[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<Dataset[]>((o: Subscriber<Dataset[]>) => {
      const emitData = (data: Dataset[]): void => {
        o.next(data);
        this.filterData.wasteCalendarDatasets = data;
        this.broadcastService.clearStale('wasteCalendarDatasets.changed');

        if (this.filters?.wasteCalendarDatasets) {
          this.filters.wasteCalendarDatasets.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<Dataset[]> => {
        if (this.filters?.wasteCalendarDatasets) {
          this.filters.wasteCalendarDatasets.isLoading = true;
        }
        return this.getWasteCalendarDatasets();
      };

      if (this.filterData.wasteCalendarDatasets.length && !this.broadcastService.isStale('wasteCalendarDatasets.updated')) {
        o.next(this.filterData.wasteCalendarDatasets);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('wasteCalendarDatasets', 'updated').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: wasteCalendarDatasets.updated');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getWasteCalendarDatasets(): Observable<Dataset[]> {
    return new Observable<Dataset[]>((o: Subscriber<Dataset[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.waste-calendar.datasets'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  wasteCalendarWasteTypes(): Observable<WasteType[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<WasteType[]>((o: Subscriber<WasteType[]>) => {
      const emitData = (data: WasteType[]): void => {
        o.next(data);
        this.filterData.wasteCalendarWasteTypes = data;
        this.broadcastService.clearStale('wasteCalendarWasteTypes.changed');

        if (this.filters?.wasteCalendarWasteTypes) {
          this.filters.wasteCalendarWasteTypes.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<WasteType[]> => {
        if (this.filters?.wasteCalendarWasteTypes) {
          this.filters.wasteCalendarWasteTypes.isLoading = true;
        }
        return this.getWasteCalendarWasteTypes();
      };

      if (this.filterData.wasteCalendarWasteTypes.length) {
        o.next(this.filterData.wasteCalendarWasteTypes);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('wasteCalendarWasteTypes', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: wasteCalendarWasteTypes.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getWasteCalendarWasteTypes(): Observable<WasteType[]> {
    return new Observable<WasteType[]>((o: Subscriber<WasteType[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.waste-calendar.waste-types'), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  wasteCalendarLocations(datasetId: number): Observable<Location[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<Location[]>((o: Subscriber<Location[]>) => {
      const emitData = (data: Location[]): void => {
        o.next(data);
        this.filterData.wasteCalendarLocations[datasetId] = data;
        this.broadcastService.clearStale('wasteCalendarLocations.changed');

        if (this.filters?.wasteCalendarLocations) {
          this.filters.wasteCalendarLocations.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<Location[]> => {
        if (this.filters?.wasteCalendarLocations) {
          this.filters.wasteCalendarLocations.isLoading = true;
        }
        return this.getWasteCalendarLocations(datasetId);
      };

      if (typeof this.filterData.wasteCalendarLocations[datasetId] !== 'undefined' && this.filterData.wasteCalendarLocations[datasetId].length) {
        o.next(this.filterData.wasteCalendarLocations[datasetId]);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('wasteCalendarLocations', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: wasteCalendarLocations.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getWasteCalendarLocations(datasetId: number): Observable<Location[]> {
    return new Observable<Location[]>((o: Subscriber<Location[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.waste-calendar.locations') + (datasetId ? '?dataset_id=' + datasetId : ''), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  wasteCalendarRoutes(datasetId: number = null): Observable<Route[]> {
    let initialSub: Subscription = null,
      wsSub: Subscription = null,
      wsDataSub: Subscription = null;
    return new Observable<Route[]>((o: Subscriber<Route[]>) => {
      const emitData = (data: Route[]): void => {
        o.next(data);
        this.filterData.wasteCalendarRoutes[datasetId] = data;
        this.broadcastService.clearStale('wasteCalendarRoutes.changed');

        if (this.filters?.wasteCalendarRoutes) {
          this.filters.wasteCalendarRoutes.isLoading = false;
        }
      };

      const loadFromServer = (): Observable<Route[]> => {
        if (this.filters?.wasteCalendarRoutes) {
          this.filters.wasteCalendarRoutes.isLoading = true;
        }
        return this.getWasteCalendarRoutes(datasetId);
      };

      if (typeof this.filterData.wasteCalendarRoutes[datasetId] !== 'undefined' && this.filterData.wasteCalendarRoutes[datasetId].length) {
        o.next(this.filterData.wasteCalendarRoutes[datasetId]);
      } else {
        initialSub = loadFromServer().subscribe(emitData);
      }

      wsSub = this.broadcastService.getEventSubject('wasteCalendarRoutes', 'changed').subscribe(() => {
        if (!environment.production) {
          console.log('WebSocket: received event for "filters" channel: wasteCalendarRoutes.changed');
        }

        wsDataSub?.unsubscribe();

        wsDataSub = loadFromServer().subscribe(emitData);
      });

      return (): void => {
        initialSub?.unsubscribe();
        wsSub?.unsubscribe();
        wsDataSub?.unsubscribe();
      };
    });
  }

  getWasteCalendarRoutes(datasetId: number): Observable<Route[]> {
    return new Observable<Route[]>((o: Subscriber<Route[]>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('filters.waste-calendar.routes') + (datasetId ? '?dataset_id=' + datasetId : ''), null, true).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(response.data);
            o.complete();
          } else {
            o.next([]);
            o.complete();
          }
        },
        (): void => {
          o.next([]);
          o.complete();
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }
}
